<script>
import { throttle } from "throttle-debounce";

const breakpoints = {
  mobile: [0, 767],
  tablet: [768, 991],
  desktop: [992, Infinity]
};

const between = (value, range) => {
  return value >= range[0] && value <= range[1];
};

const normalize = value => value.split(",").map(item => item.trim().toLowerCase());

const getCurrentBreakpoint = () => {
  const clientWidth = window.innerWidth;

  return Object.keys(breakpoints).find(breakpoint => between(clientWidth, breakpoints[breakpoint]));
};

export default {
  props: {
    /**
     * Sets breakpoint when will visible default slot ["mobile", "tablet", "desktop", "mobile,tablet"]
     */
    breakpoint: {
      type: String,
      required: true,
      validator: value => normalize(value).filter(item => !breakpoints[item]).length === 0
    }
  },
  data() {
    const normalized = normalize(this.breakpoint);

    return {
      normalized,
      shouldRender: normalized.indexOf(getCurrentBreakpoint()) !== -1
    };
  },
  mounted() {
    this.handleResize = throttle(60, () => {
      this.shouldRender = this.normalized.indexOf(getCurrentBreakpoint()) !== -1;
    });

    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  render(h) {
    const children = this.shouldRender ? this.$slots.default : this.$slots.else;

    if (!children) {
      return null;
    }

    if (children.length === 1) {
      return children[0];
    }

    return h("div", null, children);
  }
};
</script>
